import { Rectangle } from "@/types";

/**
 * Creates a crop from the top left corner that maintains the given aspect ratio
 */
export const calculateCropForAspectRatioChange = (
  imageWidth: number,
  imageHeight: number,
  newAspectRatio: number,
): Rectangle | null => {
  if (!imageWidth || !imageHeight || !newAspectRatio) {
    return null;
  }

  let cropWidth: number;
  let cropHeight: number;

  // Calculate the maximum possible crop size that fits within the image bounds
  // while maintaining the new aspect ratio
  if (newAspectRatio > 1) {
    // Landscape preset - width is the limiting factor
    cropWidth = imageWidth;
    cropHeight = cropWidth / newAspectRatio;

    // If height exceeds image bounds, adjust based on height
    if (cropHeight > imageHeight) {
      cropHeight = imageHeight;
      cropWidth = cropHeight * newAspectRatio;
    }
  } else {
    // Portrait or square preset - height is the limiting factor
    cropHeight = imageHeight;
    cropWidth = cropHeight * newAspectRatio;

    // If width exceeds image bounds, adjust based on width
    if (cropWidth > imageWidth) {
      cropWidth = imageWidth;
      cropHeight = cropWidth / newAspectRatio;
    }
  }

  return {
    x: 0,
    y: 0,
    width: cropWidth,
    height: cropHeight,
  };
};
